import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getOvercomingStatistics } from './queries/queries';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';
import DataProcessor from '../../common/dataProcessors/overcomingDataProcessor';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class Overcoming extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.group.allTime.overcoming;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'all time');
  }

  render() {
    return (
      <InfoCardWidget primaryColor="#ff9500" secondaryColor="#595959" icon="icon-mountain" title="All Time Overcoming"
                      data={this.dataProcessor.data} loading={this.props.data.loading} comment={this.comment}/>
    );
  }
}

export default compose(
  graphql(getOvercomingStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(Overcoming);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/group/allTime/overcoming.js